import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar, FaUserCircle } from 'react-icons/fa';
import './YorumCard.css';

const YorumCard = ({ yorum }) => {
  const renderStars = (puan) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= puan) {
        stars.push(<FaStar key={i} className="star filled" />);
      } else if (i - 0.5 <= puan) {
        stars.push(<FaStarHalfAlt key={i} className="star filled" />);
      } else {
        stars.push(<FaRegStar key={i} className="star" />);
      }
    }
    return stars;
  };

  return (
    <div className="yorum-card">
      <div className="yorum-header">
        <FaUserCircle className="yorum-avatar" />
        <div>
          <h4>{yorum.musteri_adi}</h4>
          <div className="yorum-stars">{renderStars(yorum.puan)}</div>
        </div>
      </div>
      <p className="yorum-text">"{yorum.yorum}"</p>
    </div>
  );
};

export default YorumCard;
